import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDownOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m2 9 .99-.99 4.31 4.31V1h1.4v11.32l4.31-4.31L14 9l-6 6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowDownOutlinedSize16Glyph.displayName = 'ArrowDownOutlinedSize16Glyph';
